'use client';
import * as RadixProgress from '@radix-ui/react-progress';
import { memo, type ReactNode } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const videoSeekbarProgress = tailwindVariants({
  base: 'pointer-events-none h-1 w-full overflow-hidden rounded-4 ads:bg-input bg-gray-7',
  defaultVariants: {
    color: 'gray',
  },
  variants: {
    color: {
      gray: 'ads:text-icon-subtle text-gray-8',
      /** @deprecated Use 'gray' instead. British spelling kept for backwards compatibility (DES-25). */
      grey: 'ads:text-icon-subtle text-gray-8',
      teal: 'ads:text-ads-cyan-9 text-teal-9',
    },
  },
});

const FULL_WIDTH_PERCENTAGE = 100;

export type VideoSeekbarProgressVariants = VariantProps<typeof videoSeekbarProgress>;

export type VideoSeekbarProgressProps = Pick<RadixProgress.ProgressProps, 'className'> &
  VideoSeekbarProgressVariants & {
    percentage: number;
    children?: ReactNode;
  };

export const VideoSeekbarProgress = memo((props: VideoSeekbarProgressProps) => {
  const { className, color, percentage, children } = props;

  return (
    <RadixProgress.Root className={videoSeekbarProgress({ className, color })}>
      <RadixProgress.Indicator
        className="size-full rounded-4 bg-current"
        style={{ transform: `translateX(-${FULL_WIDTH_PERCENTAGE - percentage}%)` }}
      />
      {children}
    </RadixProgress.Root>
  );
});

VideoSeekbarProgress.displayName = 'VideoSeekbarProgress';
